"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerTag = exports.Logo = void 0;
var _reactUse = require("react-use");
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _useUISettings = require("../AppData/useUISettings");
var _utils = require("../../common/utils");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var SpeakerTag = function SpeakerTag() {
  var dominantSpeaker = (0, _reactSdk.useHMSStore)(_reactSdk.selectDominantSpeaker);
  return dominantSpeaker && dominantSpeaker.name ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    align: "center",
    justify: "center",
    css: {
      flex: "1 1 0",
      color: "$textPrimary",
      "@md": {
        display: "none"
      }
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.VolumeOneIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "md",
      css: _objectSpread(_objectSpread({}, (0, _reactUi.textEllipsis)(200)), {}, {
        ml: "$2"
      }),
      title: dominantSpeaker.name,
      children: dominantSpeaker.name
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};
exports.SpeakerTag = SpeakerTag;
var LogoImg = (0, _reactUi.styled)("img", {
  maxHeight: "$14",
  p: "$2",
  w: "auto",
  "@md": {
    maxHeight: "$12"
  }
});
var Logo = function Logo() {
  var _useTheme = (0, _reactUi.useTheme)(),
    themeType = _useTheme.themeType;
  var logo = (0, _useUISettings.useLogo)();
  var isMobile = (0, _reactUse.useMedia)(_reactUi.config.media.md);
  var isConnected = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsConnectedToRoom);
  // Hide logo for now as there is not enough space
  if (isConnected && isMobile && (0, _utils.isStreamingKit)()) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(LogoImg, {
    src: logo,
    alt: "AstroG",
    width: 132,
    height: 40
  });
};
exports.Logo = Logo;